import React from "react";

type BuildProps = {
  color?: string;
};

const Build: React.FC<BuildProps> = ({ color = "#000" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14224_6464)">
        <path
          d="M19.25 20L19.95 19.3L11.975 11.325C12.2917 10.9417 12.5377 10.5083 12.713 10.025C12.8877 9.54167 12.975 9.03333 12.975 8.5C12.975 7.25 12.5377 6.19167 11.663 5.325C10.7877 4.45833 9.725 4.025 8.475 4.025H8.225L11.3 7.1L7.05 11.325L3.975 8.25V8.525C3.975 9.775 4.41233 10.8333 5.287 11.7C6.16233 12.5667 7.225 13 8.475 13C9.00833 13 9.51267 12.9123 9.988 12.737C10.4627 12.5623 10.8917 12.3167 11.275 12L19.25 20ZM17.85 21.425L10.95 14.525C10.5667 14.675 10.171 14.7917 9.763 14.875C9.35433 14.9583 8.93333 15 8.5 15C6.68333 15 5.146 14.3707 3.888 13.112C2.62933 11.854 2 10.3167 2 8.5C2 7.8 2.10433 7.125 2.313 6.475C2.521 5.825 2.825 5.225 3.225 4.675L7.05 8.5L8.475 7.1L4.65 3.25C5.21667 2.83333 5.825 2.52067 6.475 2.312C7.125 2.104 7.79167 2 8.475 2C10.2917 2 11.8293 2.629 13.088 3.887C14.346 5.14567 14.975 6.68333 14.975 8.5C14.975 8.93333 14.9333 9.36233 14.85 9.787C14.7667 10.2123 14.6417 10.6167 14.475 11L21.35 17.875C21.7333 18.2583 21.9293 18.729 21.938 19.287C21.946 19.8457 21.7583 20.3167 21.375 20.7L20.7 21.4C20.3167 21.8 19.8457 22.004 19.287 22.012C18.729 22.0207 18.25 21.825 17.85 21.425Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_14224_6464">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.228516)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Build;
